import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';

type AOA = any[][];

@Injectable()
export class ExcelService {
    isHeaderPresentFlag = true;
    valildateFileExtenstionFlag = true;

    constructor() {}

    isXlsxFile(file: File) {
        return file.name.endsWith('.xlsx');
    }

    getHeaderArray(data: any): AOA {
        const wb: XLSX.WorkBook = XLSX.read(data, { type: 'binary' });
        const wsname: string = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];

        const headers = <AOA>XLSX.utils.sheet_to_json(ws, { header: 1 });
        return headers[0];
    }

    validateHeaders(originHeaders: String[], fileHeaders: string[]) {
        if (originHeaders.length !== fileHeaders.length) {
            return false;
        }

        let fileHeaderMatchFlag = true;
        for (let j = 0; j < originHeaders.length; j++) {
            if (originHeaders[j] !== fileHeaders[j]) {
                fileHeaderMatchFlag = false;
                break;
            }
        }
        return fileHeaderMatchFlag;
    }
}
